
export const FORMATS_NAMES = {
  eu: {
    1: "240304 (esp) Autorización de uso de imagen y voz - Grupo Spradling",
    2: "240304 (eng) Authorization for the use of image and voice - Spradling Group",
  },
  mx: "240313 (esp) Autorización de uso de imagen y voz - Spradling - México",
  us: "240304 (eng) Authorization for the use of image and voice - Spradling Group - USA",
  la: {
    1: "231114 (esp) Autorización de uso de imagen y voz - Spradling - Colombia",
    2: "231204 (esp) Autorización de uso de fotografías - Spradling - Colombia"
  }
}

export const EU_BUTTONS_TEXTS = [
  {
    index: 1,
    id: "ProjectStepFormDisclaimer.button.downloadSpanishVersion",
    defaultMessage: "Descargar formato en español {icon}",
    order: 1,
  },
  {
    index: 0,
    id: "ProjectStepFormDisclaimer.button.downloadEnglishVersion",
    defaultMessage: "Descargar formato en inglés {icon}",
    order: 2,
  },
];

export const handleDownloadFormat = (url, userInstance, version) => {
  // Caso 1: URL único (EU, normal)
  if (typeof url === "string") {
    const link = document.createElement("a");
    link.href = url;

    if (version) link.download = `${FORMATS_NAMES[userInstance][version]}.docx`;
    else link.download = `${FORMATS_NAMES[userInstance]}.docx`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return;
  }

  // Caso 2: Varias URLs (LATAM o multi-formato)
  if (Array.isArray(url)) {
    url.forEach((singleUrl, index) => {
      const link = document.createElement("a");
      link.href = singleUrl.url;

      link.download = `${FORMATS_NAMES[userInstance][index + 1]}.docx`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  }
};